import { OkrsConstants } from "../constants/okrs.constants";

let initialState = {
    statusCode : "",
    okr_status : "",
    error : ""
}

export const add_okrReducer = (state = initialState, action) => {
      
    switch(action.type) {
        case OkrsConstants.ADD_OKR_SUCCESS :
            return {...state, okr_status : action.payload.data, statusCode : action.payload.status };
        case OkrsConstants.ADD_OKR_FAILURE :
            return { ...state, error : action.payload.data, statusCode : action.payload.status };
        default : 
            return state;
    }
}